import { motion } from "framer-motion";
import Stack from "../../components/Utils/Stack.styled";
import { Outlet, useLocation, useParams } from "react-router-dom";
import VideoGrid from "../../components/VideoGrid";
import { useState, useRef, useEffect } from "react";
import { searchVideo } from "../../helper/useApiHelper";
import Wrap from "../../components/Utils/Wrap.styled";
import SkeletonLoader from "../../components/SkeletonLoader/SkeletonLoader";
import VideoPlayer from "../../components/VideoPlayer";
import ErrorMessage from "../../components/ErrorMessage";
import CONSTANT from "../../constants/constant";
import useQueueStore from "../../stores/queueStore";
import Queue from "../../components/Queue";
import uuid from "react-uuid";
import usePlayListStore from "../../stores/playlistStore";
import Playlists from "../../components/Playlists/Playlists";
import { useErrorState } from "../../contexts/errorContext";

const VideoSearchResults = () => {
  const param = useLocation();
  const { videoId } = useParams();
  const [selectedVideo, setSelectedVideo] = useState("");
  const constraintsRef = useRef(null);
  const { setIsError } = useErrorState();
  const { data, isLoading, error } = searchVideo(param.search.slice(3));
  const currentQueue = useQueueStore((state) => state.currentQueues);
  const updateQueueStatus = useQueueStore((state) => state.updateQueueStatus);
  const addQueue = useQueueStore((state) => state.addQueue);
  const currentPlayingPlaylist = usePlayListStore(
    (state) => state.currentPlayingPlaylist
  );
  const clearCurrentPlayingPlaylist = usePlayListStore(
    (state) => state.clearCurrentPlayingPlaylist
  );

  useEffect(() => {
    if (currentPlayingPlaylist) {
      const allVideos = currentPlayingPlaylist?.videos;
      if (currentPlayingPlaylist?.videos) {
        const index = allVideos.findIndex((it) => it.isPlayingNow);
        if (index !== -1) {
          setSelectedVideo(allVideos[index]);
        }
      }
    }

    if (currentQueue.length > 0) {
      if (currentQueue.length === 1) {
        setSelectedVideo(currentQueue[0]);
      } else {
        const index = currentQueue.findIndex((it) => it.isPlayingNow);
        if (index !== -1) {
          setSelectedVideo(currentQueue[index]);
        }
      }
    }
  }, [
    currentQueue,
    currentPlayingPlaylist,
    currentPlayingPlaylist?.videos,
    selectedVideo,
  ]);

  const onSelectedVideoId = (id, title, image) => {
    const videoDetail = {
      id: uuid(),
      videoId: id,
      title: title,
      thumbnailUrl: image,
      isPlayingNow: true,
    };
    setSelectedVideo(videoDetail);
    clearCurrentPlayingPlaylist();

    if (currentQueue.length > 0) {
      // find current playing index
      const currentVideoIndex = currentQueue.findIndex(
        (item) => item.isPlayingNow
      );
      if (currentVideoIndex !== -1) {
        //update current video status
        updateQueueStatus(currentVideoIndex, false);
        addQueue(videoDetail, currentVideoIndex);
      } else {
        addQueue(videoDetail);
      }
    }
  };

  const RenderErrorState = () => {
    return (
      <ErrorMessage
        title={CONSTANT.ERROR.TITLE}
        message={CONSTANT.ERROR.NOT_FOUND_MESSAGE}
      />
    );
  };

  const renderTemplate = () => {
    if (error || (data && data.data.status === false)) {
      setIsError(true);
      return <RenderErrorState />;
    }

    if (isLoading) {
      return <SkeletonLoader grid={!videoId ? 1 : 0} />;
    }

    return (
      <motion.div
        style={{ width: "100%", paddingBottom: "40px" }}
        initial={{ opacity: 0, x: videoId ? "100vh" : "0" }}
        animate={{ opacity: 1, x: "0" }}
        transition={{
          type: "spring",
          damping: 60,
          mass: 1,
          stiffness: 200,
        }}
      >
        <VideoGrid
          param={param.search.slice(3)}
          onSelectedVideoId={onSelectedVideoId}
          videoList={data}
          grid={!videoId ? 1 : 0}
          currentSelectedVideoId={videoId}
        />
      </motion.div>
    );
  };

  return (
    <motion.div
      style={{
        minHeight: "100vh",
        height: "100vh",
      }}
      ref={constraintsRef}
    >
      <Stack
        direction="column"
        alignItems="start"
        justifyContent="start"
        paddingTop={!videoId ? "70px" : "110px"}
        paddingBottom="70px"
        paddingLeft="40px"
        paddingRight="40px"
      >
        <Wrap direction="row" gap="24">
          <Stack direction="column" gap="24" height="fit-content" width="180%">
            {selectedVideo && (
              <VideoPlayer
                ref={constraintsRef}
                videoId={videoId}
                selectedVideo={selectedVideo}
                param={param.search.slice(3)}
                onClose={(val) => setSelectedVideo(val)}
              />
            )}
            <Outlet />
          </Stack>
          {videoId && (
            <Stack direction="column" gap="24">
              {currentPlayingPlaylist && <Playlists />}
              <Queue />
              {renderTemplate()}
            </Stack>
          )}
        </Wrap>
        {!videoId && renderTemplate()}
      </Stack>
    </motion.div>
  );
};

export default VideoSearchResults;
